import React from "react";
import { Outfit } from "../Outfit";
import { ClothingCard } from "../../clothing/ClothingCard";

export const IndividualOutfitPieceGrid = ({ outfit = null }) => {
	return !outfit ? (
		""
	) : (
		<div className="flex h-full w-full">
			<div className="flex w-full">
				<div
					className={`rounded-md justify-center w-full grid grid-cols-2 grid-rows-2
        sm:grid-cols-2 
        md:grid-cols-3 
        lg:grid-cols-2 
        xl:grid-cols-3 `}
				>
					{outfit.outfit_pieces.map((outfit_piece) => {
						if (outfit_piece.piece_id) {
							return (
								<ClothingCard
									key={outfit_piece.piece_id}
									piece={outfit_piece}
								/>
							);
						}
					})}
				</div>
			</div>
		</div>
	);
};
